var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15711_63122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7101 5.29087L7.71018 0.290873C7.61508 0.199832 7.50293 0.128467 7.38018 0.0808729C7.13672 -0.0191451 6.86364 -0.0191451 6.62018 0.0808729C6.49743 0.128467 6.38529 0.199832 6.29018 0.290873L1.29018 5.29087C1.19694 5.38411 1.12298 5.4948 1.07252 5.61662C1.02206 5.73845 0.996094 5.86901 0.996094 6.00087C0.996094 6.26717 1.10188 6.52257 1.29018 6.71087C1.47849 6.89918 1.73388 7.00496 2.00018 7.00496C2.26648 7.00496 2.52188 6.89918 2.71018 6.71087L6.00018 3.41087V11.0009C6.00018 11.2661 6.10554 11.5204 6.29307 11.708C6.48061 11.8955 6.73496 12.0009 7.00018 12.0009C7.2654 12.0009 7.51975 11.8955 7.70729 11.708C7.89482 11.5204 8.00018 11.2661 8.00018 11.0009V3.41087L11.2901 6.71087C11.3831 6.8046 11.4937 6.879 11.6156 6.92976C11.7374 6.98053 11.8681 7.00667 12.0001 7.00667C12.1322 7.00667 12.2629 6.98053 12.3847 6.92976C12.5066 6.879 12.6172 6.8046 12.7101 6.71087C12.8039 6.61791 12.8783 6.50731 12.929 6.38545C12.9798 6.26359 13.0059 6.13288 13.0059 6.00087C13.0059 5.86886 12.9798 5.73816 12.929 5.6163C12.8783 5.49444 12.8039 5.38384 12.7101 5.29087Z",
    fill: "#055094"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15711_63122"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueArrow);
export default __webpack_public_path__ + "static/media/blue-arrow.30787aa9.svg";
export { ForwardRef as ReactComponent };